import { cn } from "@/lib/utils/cn";

/**
 * Base skeleton component for loading states
 * @param {Object} props - Component props
 * @param {'line'|'block'|'card'|'circle'|'avatar'} [props.variant='line'] - Skeleton variant
 * @param {string} [props.className] - Additional CSS classes
 * @param {React.ReactNode} [props.children] - Optional children
 */
export function SkeletonBase({ variant = "line", className, children }) {
  const variantClasses = {
    line: "h-4 w-full",
    block: "h-10 w-full",
    card: "h-24 w-full",
    circle: "h-12 w-12 rounded-full",
    avatar: "h-10 w-10 rounded-full",
  };

  return (
    <div className={cn("animate-pulse bg-base-300 rounded-md", variantClasses[variant], className)}>
      {children}
    </div>
  );
}
